import { useEffect, useMemo, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import { useDispatch, useSelector } from 'react-redux';

import { crearConcepto } from '../../../../actions/conceptosExternos';
import { buscarUnidades } from '../../../../actions/configuracion';

const opcionesTipo = [
    { value: 1, label: 'Producto' },
    { value: 2, label: 'Servicio' }
];

const NuevoConceptoModal = ({ show, onHide, onSuccess, idProyecto }) => {
    const dispatch = useDispatch();

    const { listado: listado_unidades } = useSelector(state => state.configuracion.unidades);

    const [tipoSel, setTipoSel] = useState(null);
    const [detalle, setDetalle] = useState('');
    const [cantidad, setCantidad] = useState('');
    const [unidadSel, setUnidadSel] = useState(null);
    const [precioUnitario, setPrecioUnitario] = useState('');
    const [iva, setIva] = useState(false);
    const [guardando, setGuardando] = useState(false);

    useEffect(() => {
        if (!show) return;

        if (!listado_unidades?.length) {
            dispatch(buscarUnidades());
        }
    }, [show, listado_unidades, dispatch]);

    useEffect(() => {
        if (show) return;

        setTipoSel(null);
        setDetalle('');
        setCantidad('');
        setUnidadSel(null);
        setPrecioUnitario('');
        setIva(false);
        setGuardando(false);
    }, [show]);

    const opcionesUnidades = useMemo(() => {
        return (listado_unidades || []).map(u => ({
            value: u._id,
            label: u.nombre
        }));
    }, [listado_unidades]);

    const unidadRequerida = tipoSel?.value !== 2;

    const puedeGuardar = useMemo(() => {
        return Boolean(
            tipoSel?.value &&
            detalle.trim().length > 0 &&
            Number(cantidad) > 0 &&
            (!unidadRequerida || unidadSel?.value) &&
            !guardando
        );
    }, [tipoSel, detalle, cantidad, unidadSel, unidadRequerida, guardando]);

    const onGuardar = async () => {
        if (!puedeGuardar || !idProyecto) return;

        setGuardando(true);
        const ok = await dispatch(crearConcepto({
            id_proyecto: idProyecto,
            tipo: tipoSel.value,
            detalle: detalle.trim(),
            cantidad: Number(cantidad),
            unidad: unidadSel?.value || null,
            precio_unitario: Number(precioUnitario || 0),
            iva
        }));
        setGuardando(false);

        if (!ok) return;

        if (typeof onSuccess === 'function') {
            onSuccess();
        } else if (typeof onHide === 'function') {
            onHide();
        }
    };

    return (
        <Modal show={show} onHide={onHide} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Agregar concepto</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mb-3">
                    <div className="text-muted small mb-1">Tipo</div>
                    <Select
                        options={opcionesTipo}
                        value={tipoSel}
                        onChange={setTipoSel}
                        placeholder="Tipo..."
                        noOptionsMessage={() => 'Sin resultados'}
                    />
                </div>

                <div className="mb-3">
                    <div className="text-muted small mb-1">Detalle</div>
                    <textarea
                        className="form-control"
                        placeholder="Detalle"
                        rows={3}
                        value={detalle}
                        onChange={(e) => setDetalle(e.target.value)}
                    />
                </div>

                <div className="row">
                    <div className="col-6 mb-3">
                        <div className="text-muted small mb-1">Cantidad</div>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Cantidad"
                            value={cantidad}
                            onChange={(e) => setCantidad(e.target.value)}
                        />
                    </div>
                    <div className="col-6 mb-3">
                        <div className="text-muted small mb-1">{unidadRequerida ? 'Unidad' : 'Unidad (opcional)'}</div>
                        <Select
                            options={opcionesUnidades}
                            value={unidadSel}
                            onChange={setUnidadSel}
                            isClearable={!unidadRequerida}
                            placeholder={unidadRequerida ? 'Unidad...' : 'Unidad (opcional)...'}
                            noOptionsMessage={() => 'Sin resultados'}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-8 mb-3">
                        <div className="text-muted small mb-1">Precio unitario</div>
                        <CurrencyInput
                            value={precioUnitario}
                            decimalsLimit={3}
                            allowNegativeValue={false}
                            placeholder="$ Precio unitario"
                            className="form-control"
                            prefix="$ "
                            groupSeparator=","
                            decimalSeparator="."
                            onValueChange={(value) => setPrecioUnitario(value || '')}
                        />
                    </div>
                    <div className="col-4 mb-3 d-flex align-items-center">
                        <Form.Check
                            type="checkbox"
                            id="nuevo-concepto-iva"
                            label="IVA"
                            checked={iva}
                            onChange={(e) => setIva(e.target.checked)}
                        />
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={onHide} disabled={guardando}>
                    Cancelar
                </button>
                <button type="button" className="btn btn-primary" onClick={onGuardar} disabled={!puedeGuardar}>
                    Guardar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default NuevoConceptoModal;
